import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Roles() {
  return (
    <ScaffoldPage
      title="Roles & Permissions"
      description="Define custom roles and configure granular permissions for your team."
      breadcrumbs={buildBreadcrumbs('/settings/team/roles')}
      plannedFeatures={[
        'Create custom roles beyond Admin and Member',
        'Product-scoped permissions (Engage, Coach, Identity)',
        'Granular API access controls per role',
        'Role templates for common team structures',
      ]}
      relatedPages={[
        { label: 'Team Members', href: '/settings/team/members' },
        { label: 'Access Audit Log', href: '/settings/team/audit' },
      ]}
    />
  )
}
